<template>
  <v-row>
    <v-col cols="3" class="d-flex align-center justify-center">
      <img
        src="@/assets/user.png"
        class="pa-lg-3"
        style="width: 100% !important"
        alt="User"
      />
    </v-col>
    <v-col cols="9">
      <v-row no-gutters>
        <v-col cols="11">
          <DriverTooltipWithIcon
            icon="mdi-account-box"
            :text="driver.name"
            :label="`${fleetModule.driver} Name`"
          />
        </v-col>
        <v-col cols="1">
          <v-tooltip
            right
            color="rgb(0 0 0 / 100%)"
            v-if="driver && driver.zones && driver.zones.length > 0"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-icon size="20" color="unassigned" class="pl-1">
                  mdi-alpha-z-box
                </v-icon>
              </span>
            </template>
            <span class="text-capitalize">
              <span><b>Assigned Zone</b></span
              ><br />
              <span><hr class="mt-2 mb-3" /></span>
              <span v-for="(zone, index) in driver.zones" :key="index">
                {{ zone }} <br />
              </span>
            </span>
          </v-tooltip>
        </v-col>
        <v-col cols="11">
          <DriverTooltipWithIcon
            icon=" mdi-cellphone"
            :text="driver.contact_number"
            :label="`${fleetModule.driver} contact number`"
          />
        </v-col>
        <v-col cols="1">
          <v-tooltip
            right
            v-if="driver && driver.tags && driver.tags.length > 0"
            color="rgb(0 0 0 / 100%)"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-icon size="20" color="unassigned" class="pl-1">
                  mdi-alpha-t-box
                </v-icon>
              </span>
            </template>
            <span class="text-capitalize">
              <span><b>Assigned Tags</b></span
              ><br />
              <span><hr class="mt-2 mb-3" /></span>
              <span v-for="(tag, index) in driver.tags" :key="index">
                {{ tag }} <br />
              </span>
            </span>
          </v-tooltip>
        </v-col>
        <v-col cols="6">
          <DriverTooltipWithIcon
            icon=" mdi-truck"
            :text="driver.vehicle_number"
            :label="`${fleetModule.vehicle} assigned`"
          />
        </v-col>
        <v-col cols="6" class="text-right pr-3 cf-card-space">
          <span class="caption text-capitalize cf-card-text">
            {{ driver.status }}</span
          >
          <v-avatar
            :color="coloredDriverStatus(driver.status)"
            size="16"
            class="ml-2"
          >
          </v-avatar>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { fleetModule } from "@/utils/moduleMapping";
import DriverTooltipWithIcon from "@/components/ModuleBasedComponents/TripPlanning/DriverTooltipWithIcon.vue";

export default {
  components: { DriverTooltipWithIcon },
  props: {
    driver: {
      type: Object,
    },
  },
  methods: {
    coloredDriverStatus(status) {
      switch (status) {
        case "Off Duty":
          return "off_duty";
        case "On Duty":
          return "on_duty";
        default:
          return "#ffffff";
      }
    },
  },
  data() {
    return {
      fleetModule,
    };
  },
};
</script>

<style></style>
